import IncPageBody from 'components/inc-page/inc-page-body/inc-page-body.component';
import IncPageHeader from 'components/inc-page/inc-page-header/inc-page-header.component';
import IncPageTabPanels from 'components/inc-page/inc-page-tab-panels/inc-page-tab-panels.component';
import { IncPageTabPanelsProvider } from 'components/inc-page/inc-page-tab-panels/inc-page-tab-panels.context';
import { useSetInitialTabAsDefault } from 'components/inc-page/inc-page-tab-panels/inc-page-tab-panels.hooks';
import IncPageTitle from 'components/inc-page/inc-page-title/inc-page-title.component';
import IncPage from 'components/inc-page/inc-page.component';
import { useHasAccessTier } from 'hooks/authorization.hooks';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const EmailPulse = () => {
  const { t } = useTranslation();
  const hasClientAccess = useHasAccessTier('client');

  const tabs = useMemo(
    () =>
      [
        hasClientAccess && {
          label: t('page.emailPulse.tabs.overview.label'),
          path: 'overview',
        },
        {
          label: t('page.emailPulse.tabs.messages.label'),
          path: 'messages',
        },
        {
          label: t('page.emailPulse.tabs.offers.label'),
          path: 'offers',
        },
        {
          label: t('page.emailPulse.tabs.orders.label'),
          path: 'orders',
        },
        hasClientAccess && {
          label: t('page.emailPulse.tabs.giftCards.label'),
          path: 'gift-cards',
        },
        hasClientAccess && {
          label: t('page.emailPulse.tabs.securityAndAccess.label'),
          path: 'security',
        },
      ].filter(Boolean),
    [t, hasClientAccess],
  );

  useSetInitialTabAsDefault(tabs);

  return (
    <IncPage>
      <IncPageHeader>
        <IncPageTitle />
      </IncPageHeader>
      <IncPageBody>
        <IncPageTabPanelsProvider
          tabs={tabs}
          options={{ keepSearchParams: true }}
        >
          <IncPageTabPanels />
        </IncPageTabPanelsProvider>
      </IncPageBody>
    </IncPage>
  );
};

export default EmailPulse;
